@if(showTable) {
<p-table [globalFilterFields]="[
    'route_name',
    'bl_name',
    'task_point_name',
    'address',
    'postal_code',
    'delivery_point_area_name',
    'pn_item_id',
    'consignee_name',
    'user_name',
    'item_state',
    'source'
    ]" #dataTable  columnResizeMode="expand" [value]="unloadedData" [resizableColumns]="true" [columns]="visibleColumns"  [rowHover]="true"
    [scrollable]="true" scrollHeight="flex" (onColResize)="saveColumnWidth($event)"
    [loading]="taskInfoService.loading" [(selection)]="taskMovementService.selectedOptionsForTaskMove"
    [metaKeySelection]="taskInfoService.metaKey"  [virtualScroll]="true"
    [virtualScrollItemSize]="32"
    [style]="{width:'100%'}"
    (onHeaderCheckboxToggle)="onSelectAllToggle($event)"
    [customSort]="isCustomSort"
    [multiSortMeta]="taskInfoService.multiSortMetaIndexCol"
    (onSort)="onColumnSort($event)" 
    (onRowSelect)="onUnloadedItemSelection($event.data)"
    (onRowUnselect)="onUnloadedItemUnselection($event.data)"
    sortMode="multiple"
    dataKey="item_id" selectionMode="multiple" [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}">
    <ng-template pTemplate="loadingicon">
        <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
            <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
        </svg>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="width: 1.5rem" id="rowHighlight-header" [ngClass]="{'custom-sort-icon':taskInfoService.router.url != navigation.MapLeaflet, 'custom-sort-mapview':taskInfoService.router.url == navigation.MapLeaflet}">
                @if(taskMovementService.taskmoveCount()){
                <div>
                    <img [src]="sortingService.isCustomSortApplied ? '../../../../../../assets/image/sort_selected.svg' : '../../../../../../assets/image/sort.svg'" (click)="setSelectedTaskSorting()"
                        class="icons-task-bank" onKeyDown="setSelectedTaskSorting()"
                        pTooltip="To sort by selected tasks" [hidden]="isSelectAll"/>
                </div>
                }
            </th>
            <ng-container>
                <th id="rowHighlight-header" style="width: 2.5rem">S.No.
                </th>
            </ng-container>
            <th id="checkbox-header" style="width: 2.7rem; ">
                @if (dataTable.filteredValue??unloadedData | selectionRowAllowed) {
                    <p-tableHeaderCheckbox  />
                }
        </th>
            <th id="indicators-header" style="width: 3.5rem;">
                <i class="pi pi-flag"  pTooltip="Shipment Indicators"></i>
            </th>
            <th *ngFor="let column of visibleColumns" pResizableColumn  [ngStyle]="{'width': column.width}" [id]="column.field" scope="col"
                [pSortableColumn]="column.field">
                {{column.label}}<p-sortIcon [field]="column.field" />
            </th>
        </tr>
    </ng-template>
    <ng-template let-rowIndex="rowIndex" pTemplate="body" let-unloadedData>
        <tr [pSelectableRow]="unloadedData.isMovementAllowed ? unloadedData : null"
            [pSelectableRowDisabled]="!unloadedData.isMovementAllowed" [pSelectableRowIndex]="rowIndex">
            <td id="rowHighlight-header" class="custom-sort-icon"></td>
            <ng-container >
                <td><span>{{unloadedData.index}}</span></td>
            </ng-container>
            <td>
                <ng-container *ngIf="unloadedData.isMovementAllowed; else showErrorMsg">
                    <p-tableCheckbox [pSelectableRow]="unloadedData" [value]="unloadedData"></p-tableCheckbox>
                </ng-container>
                <ng-template #showErrorMsg>
                    <i class="pi pi-info-circle info-icon" [pTooltip]="taskInfoService.taskMovementErrorMsg" appendTo="body" autoHide="false" tooltipStyleClass="taskmovement-error-tooltip"></i>
                </ng-template>
            </td>
            <td class="indicator-cell">
                <div class="indicator-rail">
                    @for(indicator of unloadedData?.indicators; track indicator.key; let i = $index) {
                        @if(i < 2) {
                            <img [src]="indicator.icon"
                                [pTooltip]="indicator.label"
                                tooltipPosition="bottom"
                                class="indicator-icon"
                                width="16" height="16"
                                [alt]="indicator.label" />
                        }
                    }
                    @if(unloadedData?.indicators?.length > 2) {
                        <span class="indicator-overflow"
                            (click)="showIndicatorPanel($event, unloadedData); $event.stopPropagation()">
                            +{{unloadedData.indicators.length - 2}}
                        </span>
                    }
                </div>
            </td>
            <ng-container *ngFor="let col of visibleColumns">
                <td class="wrapRowData" [pTooltip]="unloadedData[col.field]" tooltipPosition="bottom"
                    *ngIf="col.field !== 'pn_item_id'">
                    {{unloadedData[col.field]}}
                </td>
                <td *ngIf="col.field === 'pn_item_id'">
                    <a href="javascript:void(0)" (click)="barcodeClicked(unloadedData)">{{
                        unloadedData?.pn_item_id}}</a>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="visibleColumns.length + 4">
                <div class="text-center no-record-label">
                    No Records found.
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
}
<div class="taskBankSummary">
    @if(taskMovementService.taskmoveCount()){
        <div>
            <p-tag value="{{taskMovementService.taskmoveCount()}} {{taskMovementService.taskmoveCount() == 1 ? 'item' : 'items'}} selected" 
            class="primary-chip"/>
        </div>      
        @for(kpi of taskMovementService.selectedTaskKPI; track kpi){
            @if(kpi.key==='task_type'){
            <div class="kpi-footer-props" [pTooltip]="kpi.value.toString()" tooltipPosition="top">{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b></div>
            }
            @else {
            <div>{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b>
            </div>
            }

        }
    }
</div>

<!-- <p-overlayPanel #indicatorFilterPanel [dismissable]="true" [style]="{width: '240px'}">
    <div class="indicator-filter-container">
        <p-multiSelect
            [options]="indicatorFilterOptions"
            [(ngModel)]="selectedIndicatorKeys"
            optionLabel="label"
            optionValue="value"
            placeholder="Filter by indicator"
            [showHeader]="false"
            [filter]="false"
            [style]="{width: '100%'}"
            (onChange)="filterByIndicators()">
            <ng-template let-option pTemplate="item">
                <div class="d-flex align-items-center gap-2">
                    <img [src]="option.icon" width="14" height="14" [alt]="option.label" />
                    <span>{{option.label}}</span>
                </div>
            </ng-template>
        </p-multiSelect>
        <button type="button" class="pn-button pn-button-primary pn-button-sm mt-2"
            (click)="clearIndicatorFilter(indicatorFilterPanel)">Clear</button>
    </div>
</p-popover> -->

<p-popover #indicatorPanel [dismissable]="true" [style]="{width: '220px'}">
    <div class="indicator-panel-list">
        @for(indicator of activeIndicators; track indicator.key) {
            <div class="indicator-panel-row">
                <img [src]="indicator.icon" width="16" height="16" [alt]="indicator.label" />
                <span>{{indicator.label}}</span>
            </div>
        }
    </div>
</p-popover>